<template>
    <div class="login-form-home text-align-left">
        <div class="login-form-wrapper">
          <div class="bp-logo">
              <img src="@/assets/images/logos/BP.png" alt="logo">
              <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
              <div class="logo-text">{{ $t('OUTER_PAGES.common.subheading')}}</div>
          </div>
          <form v-loading-form="loadingForm" class="form" name="forgotPasswordForm" novalidate @submit.prevent="onForgotPasswordFormSubmitted">
              <div class="text-center loginForm forgotten-password loginForm-default">
                <div v-if="(errors.items.length || instructionsSent || serverError) && formSubmitted">
                  <div class="info-block text-left margin-bottom-20" v-if="instructionsSent">
                    {{ $t('OUTER_PAGES.forgottenPassword.instruction')}}
                  </div>
                  <div class="error-wrapper" v-if="(errors.items.length || serverError) && formSubmitted">
                      <div class="error" v-if="serverError">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{$t('OUTER_PAGES.forgottenPassword.notRegistered')}}
                      </div>
                      <div class="error" v-if="serverError && otherError">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{$t('OUTER_PAGES.forgottenPassword.otherError')}}
                      </div>
                      <div class="error" v-if="(errors.has('email') && formSubmitted)">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ errors.first('email') }}
                      </div>
                  </div>
                </div>

                <div class="error" v-if="accountNotCompleted">
                  <img src="@/assets/images/icons/error-icon.png" alt="">
                  {{$t('OUTER_PAGES.forgottenPassword.accountNotCompleted')}}
                </div>

                <div class="form-group inputLogin">
                  <input
                    id="email"
                    :class="{'error-input': (errors.has('email') && formSubmitted)}"
                    @input="serverError = false"
                    :disabled="instructionSentInterval"
                    type="email"
                    class="form-control"
                    :placeholder="$t('OUTER_PAGES.forgottenPassword.email')"
                    name="email"
                    v-model="email"
                    v-validate="'required|email'" />
                </div>
              </div>

              <div class="text-center loginStructure">
                <button type="submit"
                  class="btn buttonOnLogin"
                  :disabled="instructionSentInterval"
                  :class="{'btn-type-2': instructionSentInterval, 'btn-type-1': !instructionSentInterval}"
                  >
                  <span class="button-content">
                    {{submitBtnText}}
                  </span>
                  </button>
              </div>
          </form>
        </div>
    </div>
</template>

<script>
import ApiService from '@/common/api.service'
import STATUS_CODES from '@/common/statusCodes'
import { PASSWORD_RESET_URL } from '@/constants/ApiConstants'

const resendPasswordTime = 60

export default {
  name: 'ForgottenPassword',
  data () {
    return {
      email: '',
      formSubmitted: false,
      instructionsSent: false,
      serverError: false,
      otherError : false,
      submitBtnText: this.$t('OUTER_PAGES.forgottenPassword.retrivePass'),
      instructionSentInterval: null,
      resendPasswordCountdown: resendPasswordTime,
      loadingForm: false,
      accountNotCompleted : false
    }
  },
  methods: {
    onForgotPasswordFormSubmitted () {
      this.$validator.validateAll().then(result => {
        this.loadingForm = true
        this.formSubmitted = true

        if (result) {
          this.$amplitude.logEvent('pwa: submit retrieve password')
          ApiService.post(PASSWORD_RESET_URL, { email: this.email })
            .then((data) => {
              if (data.status.code === "BP_403") {
                this.accountNotCompleted = true;
              } else {
                this.resendPasswordTimer()
                this.instructionsSent = true
                this.serverError = false
              }
              this.loadingForm = false
            })
            .catch(({ status }) => {
              if (status.code === STATUS_CODES.BP_404) {
                this.serverError = true
              } else {
                this.otherError = true
              }
              this.loadingForm = false
            })
        } else {
          this.loadingForm = false
        }
      })
    },
    clearInstructionInterval () {
      clearInterval(this.instructionSentInterval)
      this.instructionSentInterval = null
      this.submitBtnText = this.$t('OUTER_PAGES.forgottenPassword.resend')
      this.resendPasswordCountdown = resendPasswordTime
    },
    resendPasswordTimer () {
      this.instructionSentInterval = setInterval(() => {
        this.submitBtnText = `${this.$t('OUTER_PAGES.forgottenPassword.pleaseWait')} ${this.resendPasswordCountdown} ${this.$t('OUTER_PAGES.forgottenPassword.seconds')}`
        this.resendPasswordCountdown = this.resendPasswordCountdown - 1

        if (this.resendPasswordCountdown < 0) {
          this.clearInstructionInterval()
        }
      }, 1000)
    }
  }
}
</script>
